import React from 'react';
import { Container } from '../../atoms/container/Container';
import { Text } from '../../atoms/text/Text';
import CustomSelect from '../../atoms/select/CustomSelect';
import { Flex } from 'antd';
import style from './AmbulanceRateCard.module.scss';

interface RateCardSource {
  source: 'plan' | 'gmc' | 'company' | 'default';
  companyName?: string;
  planId?: string;
}

const getSourceTooltip = (rateCardSource: RateCardSource): React.ReactNode => {
  const { source, companyName, planId } = rateCardSource;
  if (source === 'plan') return (
    <div>
      <div>This rate card is coming from</div>
      <div>Company: {companyName ?? 'N/A'}</div>
      <div>Plan ID: {planId ?? 'N/A'}</div>
    </div>
  );
  if (source === 'gmc') return (
    <div>
      <div>This rate card is coming from</div>
      <div>Company: {companyName ?? 'N/A'}</div>
      <div>Type: GMC Rate Card</div>
    </div>
  );
  if (source === 'company') return (
    <div>
      <div>This rate card is coming from</div>
      <div>Company: {companyName ?? 'N/A'}</div>
    </div>
  );
  return 'This rate card is coming from default rate cards';
};

interface AmbulanceRateCardProps {
    rateCards: any[];
    handleRateCardChange: (value: string) => void;
    selectedRateCard: string;
    disable?: boolean;
    rateCardSource?: RateCardSource | null;
}

export const AmbulanceRateCard: React.FC<AmbulanceRateCardProps> = ({ 
    rateCards, 
    handleRateCardChange, 
    selectedRateCard,
    disable,
    rateCardSource,
}) => {
    return (
        <Container className={style.horizon_wrapper}>
            <Container className={style.label}>
                <Flex align="center" gap={6}>
                    <Text text="Ambulance Rate Card:" className={style.title} />
                    {rateCardSource && (
                        <div style={{ position: 'relative', display: 'inline-block' }} className="rate-card-info-wrapper">
                            <span style={{ cursor: 'pointer', fontSize: '14px', color: '#1890ff' }}>ℹ️</span>
                            <div className="rate-card-tooltip" style={{
                                position: 'absolute',
                                bottom: 'calc(100% + 6px)',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                backgroundColor: 'white',
                                border: '1px solid #d9d9d9',
                                borderRadius: '4px',
                                padding: '8px 12px',
                                whiteSpace: 'nowrap',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                fontSize: '12px',
                                color: '#333',
                                opacity: 0,
                                visibility: 'hidden',
                                transition: 'opacity 0.2s, visibility 0.2s',
                                zIndex: 1000,
                            }}>
                                {getSourceTooltip(rateCardSource)}
                            </div>
                        </div>
                    )}
                </Flex>
            </Container>
            <Container className={style.input_wrapper}>
                <Flex gap={10} align="center">
                    <CustomSelect 
                        width={"100%"} 
                        height={"40px"} 
                        placeHolder={""} 
                        options={rateCards} 
                        onChange={handleRateCardChange} 
                        value={selectedRateCard}
                        disable={disable}
                    />
                </Flex>
            </Container>
            <style>{`
                .rate-card-info-wrapper:hover .rate-card-tooltip {
                    opacity: 1 !important;
                    visibility: visible !important;
                }
            `}</style>
        </Container>
    );
};
